import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _JSON$stringify from "@babel/runtime-corejs3/core-js-stable/json/stringify";
import _setTimeout from "@babel/runtime-corejs3/core-js-stable/set-timeout";
import React, { useState, useCallback, useRef } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Col from "orion/lib/col";
import Row from "orion/lib/row";
import Button from "orion/lib/button";
import Modal from "orion/lib/modal";
import { CSVLink } from "react-csv";
import { viewAlertInitiated } from "../../actionCreators/appActionCreators";
import FilterAlerts from "../filterAlerts";
import AlertDetails from "../alertDetails";
import { useAlerts } from "../../contexts/alertsContext";
import { useDruvaAlerts } from "../../contexts/DruvaAlertsContext";
import { downloadAsCSV } from "../../apis";
import { toUnderscoreCase } from "../../helpers/appHelper";

var AlertsActions = function AlertsActions(props) {
  var csvLinkEl = useRef(null);
  var selectedAlert = props.selectedAlert,
      viewAlertInitiated = props.viewAlertInitiated;

  var _useAlerts = useAlerts(),
      filters = _useAlerts.filters,
      alertsCount = _useAlerts.alertsCount;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      toggleModal = _useState2[1];

  var _useState3 = useState({
    data: "",
    filename: ""
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      csvData = _useState4[0],
      setCSVData = _useState4[1];

  var _useDruvaAlerts = useDruvaAlerts(),
      updateUnseenAlertsCount = _useDruvaAlerts.updateUnseenAlertsCount,
      _useDruvaAlerts$apiCo = _useDruvaAlerts.apiConfig,
      alertsApiPath = _useDruvaAlerts$apiCo.alertsApiPath,
      accessTokenApiPath = _useDruvaAlerts$apiCo.accessTokenApiPath,
      alertsApiBaseUrl = _useDruvaAlerts$apiCo.alertsApiBaseUrl;

  var viewAlertCallback = useCallback(function () {
    if (!selectedAlert.data.viewed) {
      viewAlertInitiated(selectedAlert.id, alertsApiBaseUrl, alertsApiPath, updateUnseenAlertsCount);
    }

    toggleModal(!isOpen);
  }, [isOpen, selectedAlert]);
  var downloadCSVCallback = useCallback(function () {
    var filterParam = {};
    var alertTypeName = filters.alertTypeName,
        alertSeverity = filters.alertSeverity;

    if (alertTypeName) {
      var _filterParam;

      filterParam = (_filterParam = {}, _defineProperty(_filterParam, toUnderscoreCase("alertTypeName"), alertTypeName.value), _defineProperty(_filterParam, toUnderscoreCase("alertSeverity"), alertSeverity.value), _filterParam);
    }

    downloadAsCSV({
      pathprefix: alertsApiPath,
      accessTokenApiPath: accessTokenApiPath,
      payload: {
        filters: encodeURIComponent(_JSON$stringify(filterParam))
      }
    }).then(function (response) {
      console.log(response);
      setCSVData(response);

      _setTimeout(function () {
        csvLinkEl.current.link.click();
      }, 0);
    })["catch"](function (err) {
      console.log("Error while downloading CSV file", err);
    });
  }, [filters, csvLinkEl]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    className: "oui-d-flex oui-justify-content-between"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
    label: "View Details",
    onClick: viewAlertCallback,
    disabled: !selectedAlert,
    type: "primary"
  })), /*#__PURE__*/React.createElement("span", {
    className: "oui-text-center"
  }, "Alerts | ", alertsCount), /*#__PURE__*/React.createElement(FilterAlerts, {
    filters: filters
  }))), /*#__PURE__*/React.createElement(Modal, {
    isOpen: isOpen,
    size: "lg",
    toggle: function toggle() {
      return toggleModal(!isOpen);
    },
    header: "Alert Details",
    body: function body() {
      return /*#__PURE__*/React.createElement(AlertDetails, {
        alert: selectedAlert
      });
    },
    footer: function footer() {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
        label: "Close",
        type: "primary",
        onClick: function onClick() {
          return toggleModal(!isOpen);
        }
      }));
    }
  }));
};

AlertsActions.propTypes = {
  selectedAlert: PropTypes.object
};
var mapDispatchToProps = {
  viewAlertInitiated: viewAlertInitiated
};
export default connect(null, mapDispatchToProps)(AlertsActions);